import { render, staticRenderFns } from "./BAutocompleteWithValidation.vue?vue&type=template&id=112895c2&"
import script from "./BAutocompleteWithValidation.vue?vue&type=script&lang=js&"
export * from "./BAutocompleteWithValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports